import useSWR, { SWRConfiguration } from "swr";
import useFetcher from "@/utils/use-fetcher";
import { calcUrl } from "@/features/ui/helpers/fetcher-helpers";
import { ShippingInfo } from "@/features/my-account/types/shipping-info.type";

interface ListShippingInfosPathParameter {
  companyId: number;
}

export const listShippingInfosTemplateUrl =
  "/buyers/:companyId/shipping-infos";

export default function useListShippingInfos(
  parameter: ListShippingInfosPathParameter | undefined,
  config?: SWRConfiguration
) {
  const fetcher = useFetcher<{}, ShippingInfo[]>();

  return useSWR<ShippingInfo[]>(
    parameter
      ? { url: calcUrl(listShippingInfosTemplateUrl, parameter) }
      : null,
    fetcher,
    config
  );
}
